/* @engagexp/legendary-ui — built with tsup. See LICENSE. */

// src/SigilProvider/SigilProvider.tsx
import { createContext, useCallback, useMemo, useState } from "react";

// src/SigilProvider/types.ts
var SIGIL_THEMES = [
  "kaiser",
  "engagexp",
  "dark",
  "light"
];
var DEFAULT_SIGIL_THEME = "engagexp";

// src/SigilProvider/SigilProvider.tsx
import { jsx } from "react/jsx-runtime";
var SigilThemeContext = createContext(null);
function SigilProvider({
  theme: themeProp,
  className,
  children
}) {
  const [theme, setThemeState] = useState(themeProp ?? DEFAULT_SIGIL_THEME);
  const setTheme = useCallback((next) => {
    setThemeState(next);
  }, []);
  const value = useMemo(
    () => ({ theme, setTheme }),
    [theme, setTheme]
  );
  return /* @__PURE__ */ jsx(SigilThemeContext.Provider, { value, children: /* @__PURE__ */ jsx(
    "div",
    {
      "data-sigil-theme": theme,
      className,
      style: { colorScheme: "light dark" },
      children
    }
  ) });
}

// src/SigilProvider/useSigilTheme.ts
import { useContext } from "react";
function useSigilTheme() {
  const ctx = useContext(SigilThemeContext);
  if (!ctx) {
    throw new Error(
      'useSigilTheme() must be called inside a <SigilProvider>. Wrap your app in <SigilProvider theme="..."> at the entry point.'
    );
  }
  return ctx;
}

export {
  SIGIL_THEMES,
  DEFAULT_SIGIL_THEME,
  SigilThemeContext,
  SigilProvider,
  useSigilTheme
};
//# sourceMappingURL=chunk-2OBTXFUX.js.map